import {gql} from '@apollo/client'

export const CREATE_UPDATE_CANTERA = gql`
  mutation quarryCreateUpdate($input: QuarryCreateUpdateInput!) {
    quarryCreateUpdate(input: $input) {
      clientMutationId
      errors {
        field
        messages
      }
      quarry {
        id
      }
    }
  }
`
